import { createStore, createLogger } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import user from './modules/user'
import products from './modules/products'
import config from './modules/config'
import survey from './modules/survey'
import env from './modules/env'
import subscription from './modules/subscription'

const debug = process.env.NODE_ENV !== 'production'
const SOURCE_ONBOARDING = 'Onboarding'
const SOURCE_IN_APP = 'InApp'

const state = {
	isLoading: false,
	offset_top: 0,
	offset_bottom: 0,
	source: null,
	lastPaymentMethod: null
}

const getters = {
	getSource(state) {
		return state.source || SOURCE_ONBOARDING
	},
	getAmplitudeEventName: (state, getters) => (page) => {
		let prefix = getters.getSource === SOURCE_ONBOARDING ? SOURCE_ONBOARDING : SOURCE_IN_APP
		return prefix + page
	}
}

const actions = {}

const mutations = {
	setLoading(state, isLoading) {
		state.isLoading = isLoading

		if (isLoading) {
			document.body.style.overflow = 'hidden'
		} else {
			document.body.style.overflow = 'auto'
		}
	},

	setOffsets(state, offsets) {
		state.offset_top = offsets.top
		state.offset_bottom = offsets.bottom
	},

	setSource(state, source) {
		state.source = source
	},

	setLastPaymentMethod(state, pm) {
		state.lastPaymentMethod = pm
	}
}

const dataState = createPersistedState({
	paths: ['survey', 'subscription', 'lastPaymentMethod']
})

export default createStore({
	modules: {
		user,
		products,
		config,
		survey,
		env,
		subscription
	},
	state,
	getters,
	actions,
	mutations,
	strict: debug,
	plugins: debug ? [createLogger(), dataState] : [dataState]
})
